export default __webpack_public_path__ + "static/media/Intro.d0cf8c86.mp4";